import styled from '../../../theme/styled-with-theme';
import { pxToRem } from '../../../styles/utils';
import { mediaQueries } from '../../../styles/media-queries';

import Input from '../../Input';
import { Container } from '../LegacyPhoneNumberWidget/PhoneNumberWidget.styles';
import { PhoneNumberButton } from '../DesktopPhoneNumberWidget/DesktopPhoneNumberWidget.styles';
import { Flexbox } from '../../Flexbox';

interface EmailWidgetInputProps {
  success?: boolean;
  error?: boolean;
}

export const StyledParagraph = styled('p')`
  ${({ theme }) => `
    color: ${theme.color.emailInputBorderError};
    margin-left: ${theme.spacing.s};
    font-size: ${theme.fontSize.s};
  `}
`;

export const MobileContainer = styled(Container)`
  color: ${({ theme }) => theme.color.emailInputBorderError};
  flex: 1;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: auto;
  padding: ${({ theme }) => `0 ${theme.spacing.ml}`};
  flex-direction: column;
  ${mediaQueries.tablet} {
    flex-direction: row;
    align-items: flex-start;
    max-width: ${pxToRem(590)};
  }
`;

export const EmailInputWrapper = styled(Flexbox)`
  width: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const MobileEmailButton = styled(PhoneNumberButton)`
  margin: 0;
  width: 100%;
  max-width: ${pxToRem(366)};
  border-radius: ${({ theme }) => theme.borderRadius.input_desktop};
  font-size: ${pxToRem(18)};
  padding: ${({ theme }) => theme.spacing.m};
  margin-top: ${({ theme }) => theme.spacing.m};
  height: ${pxToRem(64)};
  min-height: ${pxToRem(64)};

  ${mediaQueries.min} {
    height: ${pxToRem(64)};
    min-height: ${pxToRem(64)};
    width: 100%;
    max-width: ${pxToRem(366)};
    border-radius: ${({ theme }) => theme.borderRadius.input_desktop};
    font-size: ${pxToRem(18)};
    padding: ${({ theme }) => theme.spacing.m};
    margin-top: ${({ theme }) => theme.spacing.m};
  }

  ${mediaQueries.tablet} {
    height: ${pxToRem(64)};
    min-height: ${pxToRem(64)};
    width: 100%;
    max-width: ${pxToRem(180)};
    border-radius: ${({ theme }) => theme.borderRadius.input_desktop};
    font-size: ${pxToRem(18)};
    padding: ${({ theme }) => theme.spacing.m};
    display: block;
    margin-top: 0;
    margin-left: ${({ theme }) => theme.spacing.s};
  }
`;

export const EmailWidgetInput = styled(Input, {
  shouldForwardProp: (prop) =>
    !['success', 'ctaText', 'error'].includes(prop as string)
})<EmailWidgetInputProps>`
  opacity: 1;
  flex: 1 1 auto;
  border: ${({ theme, error }) =>
    `${pxToRem(1)} solid ${
      error ? theme.color.emailInputBorderError : theme.color.emailInputBorder
    }`};
  background-color: ${({ theme, success }) =>
    `${success ? theme.color.emailInputBackground : theme.color.white}`};
  background-image: url(${({ success }) =>
    `${success ? '/images/green-checkmark-circle.svg' : ''}`});
  background-repeat: no-repeat;
  background-position: 3% 50%;
  height: ${pxToRem(64)};
  font-size: ${({ theme, success }) =>
    `${success ? theme.fontSize.sm : theme.fontSize.m}`};
  ${mediaQueries[0]} {
    width: 100%;
    border-radius: ${({ theme }) => theme.borderRadius.input_desktop};
    padding: ${({ theme }) => theme.spacing.m};
  }
  ${mediaQueries.min} {
    width: 100%;
    max-width: ${pxToRem(366)};
    border-radius: ${({ theme }) => theme.borderRadius.input_desktop};
    padding: ${({ theme }) => theme.spacing.m};
  }
  ${mediaQueries.desktop} {
    max-width: 100%;
    border-radius: ${({ theme }) => theme.borderRadius.input_desktop};
  }
`;
